import type { SessionWorktreeBinding } from '../session-worktree-binding.js';
import type { SessionWorktreeCache } from './session-worktree-cache.js';

export async function resolveExistingSessionParentPath(
  sessionId: string,
  cache: SessionWorktreeCache,
  discover: () => Promise<SessionWorktreeBinding | null>,
): Promise<string | undefined> {
  const cached = cache.getSessionParentPath(sessionId);
  if (cached) return cached;
  const disc = await discover();
  if (disc) {
    cache.remember(sessionId, disc);
    return cache.getSessionParentPath(sessionId);
  }
  return undefined;
}
